import { render, staticRenderFns } from "./VenueInfoModal.vue?vue&type=template&id=f3ba8f9a&"
import script from "./VenueInfoModal.vue?vue&type=script&lang=js&"
export * from "./VenueInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3ba8f9a')) {
      api.createRecord('f3ba8f9a', component.options)
    } else {
      api.reload('f3ba8f9a', component.options)
    }
    module.hot.accept("./VenueInfoModal.vue?vue&type=template&id=f3ba8f9a&", function () {
      api.rerender('f3ba8f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/BaseData/Venue/modules/VenueInfoModal.vue"
export default component.exports